import type { PortfolioTaskQuestionAnswerResource } from "api/generated";
import type { QuestionAnswer } from "portfolio/types";
import { emptyQuestionAnswer } from "portfolio/utils/questionAnswer";

export const questionAnswerFromDto = (
  questionAnswer: PortfolioTaskQuestionAnswerResource,
): QuestionAnswer => ({
  id: questionAnswer.id,
  question: questionAnswer.question,
  type: questionAnswer.type,
  order: questionAnswer.order,
  required: questionAnswer.required,
  // A ticked option that was renamed or removed since is dropped: there is no checkbox
  // left to untick it with, and the backend rejects it as outside the options.
  answer: Array.isArray(questionAnswer.answer)
    ? questionAnswer.answer.filter((option) =>
        questionAnswer.options.includes(option),
      )
    : (questionAnswer.answer ?? emptyQuestionAnswer(questionAnswer.type)),
  options: questionAnswer.options,
});

export const questionAnswerToDto = (
  questionAnswer: QuestionAnswer,
): PortfolioTaskQuestionAnswerResource => ({
  id: questionAnswer.id,
  question: questionAnswer.question,
  type: questionAnswer.type,
  order: questionAnswer.order,
  required: questionAnswer.required,
  answer: questionAnswer.answer,
  options: questionAnswer.options,
});
